import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export var GetSellTradeList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var page,
      res,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          page = _args.length > 0 && _args[0] !== undefined ? _args[0] : 1;
          _context.n = 1;
          return fetcher().get("sell-trade/list", {
            params: {
              page: page
            }
          });
        case 1:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : res.data) || null);
      }
    }, _callee);
  }));
  return function GetSellTradeList() {
    return _ref.apply(this, arguments);
  };
}();
export var cancelOrder = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(params) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return fetcher().post("sell-trade/cancel", params);
        case 1:
          return _context2.a(2, _context2.v);
      }
    }, _callee2);
  }));
  return function cancelOrder(_x) {
    return _ref2.apply(this, arguments);
  };
}();